/**
 * Append the JWT access token to protected /api/files/... URLs so <img>/<a>
 * tags can load them without JS fetch. Backed by the backend endpoint at
 * /api/files/{path} which accepts either a Cookie or `?auth=<token>` query.
 *
 *  - No-op for absolute (https://...), data: or blob: URLs.
 *  - Falls back to the raw URL if no token is available (public files).
 *  - Uses REACT_APP_BACKEND_URL to make relative URLs absolute.
 */
export function authImg(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const token = localStorage.getItem("access_token") || "";
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  const abs = url.startsWith("/") ? `${backend}${url}` : url;
  if (!token) return abs;
  const sep = abs.includes("?") ? "&" : "?";
  return `${abs}${sep}auth=${encodeURIComponent(token)}`;
}

export default authImg;
